import * as React from "react";
import Bubble from "./Bubble";
import { ICouncil } from "src/interfaces";
import axios from "axios";
import * as qs from "query-string-for-all";
import { baseUrl } from "src/constants/ApiSettings";
import Loading from "src/components/general/Loading";
import { forEach } from "p-iteration";

const radiusMapping = {
  0: 7,
  1: 8,
  2: 9,
  3: 10
};

interface IProps {
  councils: ICouncil[];
  selectedYear: string;
}

interface ITrace {
  name: string;
  revenue: number;
}

interface IState {
  traces: ITrace[];
}

function isNumber(n: any) { 
  return !isNaN(parseFloat(n)) && !isNaN(n - 0) 
}

export default class BubbleChart extends React.PureComponent<IProps, IState> {
  public state: IState = { traces: [] };

  public componentDidMount() {
      this.generateTraces(this.props.councils, this.props.selectedYear);
  }

  public componentWillReceiveProps(newProps: IProps) {
    if (newProps.selectedYear !== this.props.selectedYear || newProps.councils.length !== this.props.councils.length) {
      this.generateTraces(newProps.councils, newProps.selectedYear);
    }
  }

  public generateTraces = async (councils: ICouncil[], year: string) => {
    const traces: ITrace[] = [];
    const filteredCouncils = councils.filter(council => !!council);

    await forEach(filteredCouncils, async (council, index) => {
      await axios
        .all([
          axios.get(
            `${baseUrl}/totalOperatingRevenue?${qs.stringify({
              council: council.id,
              year
            })}`
          )
        ])
        .then(
          axios.spread((rev) => {
            const revenue = [rev].reduce(
              (acc, curr) => acc + (isNumber(curr.data[0].value) ? curr.data[0].value : 0),
              0
            );
            return revenue;
          })
        )
        .then(revenue => {
          traces[index] = { name: council.name, revenue };
        });
    });

    this.setState({ traces });
  };

  public render() {
    if (this.state.traces.length > 0) {
      const selectedCouncils = this.state.traces;
      const revenue = selectedCouncils.map(council => council.revenue);

      const sortedRevenue = revenue.sort((a, b) => a - b);

      return (
        <div className="c-bubble-chart relative flex items-end flex-wrap">
          
            {selectedCouncils.map((council, index) => {
              return (
                <div 
                  className="w-1/2 md:w-1/4 lg:w-1/2 md:pr-4 lg:pr-0"
                  key={ index }>
                  <Bubble
                    radius={ radiusMapping[sortedRevenue.indexOf(council.revenue)] }
                    label={ council.name }
                    value={`$${ ( Math.round( ( council.revenue / 1000 ) * 100) / 100 ) }M`}
                    ordinal={ index + 1 }
                  />
                </div>
              );
            })}
          
        </div>
      );
    } else {
      return <Loading vertical={true} />;
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/report/councilFinances/BubbleChart/index.tsx